import { render, staticRenderFns } from "./LocalisationById.vue?vue&type=template&id=5e8ef67a"
import script from "./LocalisationById.vue?vue&type=script&lang=ts"
export * from "./LocalisationById.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports